export default {
  "instagram-downloader": {
    title: "ตัวดาวน์โหลด Instagram — ดาวน์โหลดวิดีโอและรูปภาพ Instagram ฟรี",
    h1: "ตัวดาวน์โหลด Instagram",
    desc: "ดาวน์โหลดวิดีโอ รูปภาพ รีล หรือโพสต์ Carousel ของ Instagram ได้ฟรี ไม่ต้องล็อกอิน ไม่มีลายน้ำ ใช้งานได้บน iPhone, Android และ PC",
    metaDesc: "ตัวดาวน์โหลด Instagram ฟรี — บันทึกวิดีโอ รูปภาพ Reels และโพสต์ Carousel ของ Instagram ในคุณภาพ HD ไม่มีลายน้ำ ไม่ต้องล็อกอิน",
    keywords: "instagram downloader, ดาวน์โหลดวิดีโอ instagram, ตัวดาวน์โหลดรูปภาพ instagram, instagram downloader ฟรี",
    faq: [
      { q: "ดาวน์โหลดวิดีโอ Instagram อย่างไร?", a: "คัดลอก URL วิดีโอ Instagram วางใน InstantSaver คลิก Preview แล้วคลิก Download วิดีโอของคุณจะถูกบันทึกภายในไม่กี่วินาที" },
      { q: "ดาวน์โหลดรูปภาพ Instagram ได้ไหม?", a: "ได้ วาง URL ของโพสต์ แล้ว InstantSaver จะตรวจจับว่าเป็นรูปภาพหรือวิดีโอ และแสดงปุ่มดาวน์โหลดที่ถูกต้อง" },
      { q: "ต้องสร้างบัญชีไหม?", a: "ไม่ต้องมีบัญชีหรือล็อกอินเลย InstantSaver ฟรีและไม่ระบุตัวตนอย่างสมบูรณ์" },
      { q: "ไฟล์ที่ดาวน์โหลดมีลายน้ำไหม?", a: "ไม่มี ไฟล์ถูกดาวน์โหลดโดยตรงจาก CDN ของ Instagram ในคุณภาพต้นฉบับ — ไม่มีการเพิ่มลายน้ำ" },
    ],
    featureTitle: "สิ่งที่คุณสามารถดาวน์โหลดได้",
    features: [
      { icon: "🎬", text: "Instagram Reels — วิดีโอ HD เต็มรูปแบบ" },
      { icon: "🖼️", text: "รูปภาพและโพสต์ฟีด" },
      { icon: "🗂️", text: "โพสต์ Carousel — ทุกรูปภาพแยกกัน" },
      { icon: "📺", text: "วิดีโอยาว IGTV" },
      { icon: "👤", text: "รูปโปรไฟล์ในคุณภาพต้นฉบับ" },
    ],
  },

  "reels-downloader": {
    title: "ตัวดาวน์โหลด Instagram Reels — บันทึก Reels เป็น HD ฟรี",
    h1: "ตัวดาวน์โหลด Instagram Reels",
    desc: "บันทึก Instagram Reel ใดก็ได้ลงในอุปกรณ์ของคุณในคุณภาพ HD ไม่มีลายน้ำ ไม่ต้องสมัครสมาชิก ใช้งานได้ทันทีบนอุปกรณ์ใดก็ได้",
    metaDesc: "ดาวน์โหลด Instagram Reels เป็น HD ฟรี ไม่มีลายน้ำ ไม่ต้องล็อกอิน บันทึก Reels ลง iPhone, Android หรือ PC ได้ในไม่กี่วินาทีด้วย InstantSaver",
    keywords: "instagram reels downloader, ดาวน์โหลด instagram reels, reels saver, ดาวน์โหลด reels ฟรี",
    faq: [
      { q: "ดาวน์โหลด Instagram Reels อย่างไร?", a: "เปิด Reel บน Instagram แตะเมนูจุดสามจุด (⋯) แล้วคัดลอกลิงก์ วางใน InstantSaver แล้วคลิก Download" },
      { q: "ดาวน์โหลด Reels บน iPhone ได้ไหม?", a: "ได้ InstantSaver ใช้งานได้ใน Safari บน iPhone หลังจากดาวน์โหลด วิดีโอจะอยู่ในแอป Files หรือ Photos ของคุณ" },
      { q: "ดาวน์โหลด Reels บน Android ได้ไหม?", a: "ได้ วิดีโอจะถูกบันทึกลงในโฟลเดอร์ Downloads ของอุปกรณ์คุณโดยอัตโนมัติ" },
      { q: "Reels ที่ดาวน์โหลดเป็นคุณภาพ HD ไหม?", a: "ใช่ Reels ถูกดึงมาด้วยความละเอียดต้นฉบับ — สูงสุด 1080p หากมี" },
    ],
    featureTitle: "ทำไมต้องใช้ InstantSaver สำหรับ Reels",
    features: [
      { icon: "⚡", text: "ดาวน์โหลด Reel สาธารณะใดก็ได้ในเวลาไม่ถึง 5 วินาที" },
      { icon: "🔇", text: "ไม่มีลายน้ำ — ไฟล์ต้นฉบับที่สะอาด" },
      { icon: "📱", text: "ใช้งานได้บน iPhone, Android, แท็บเล็ต และเดสก์ท็อป" },
      { icon: "🔒", text: "ไม่ต้องล็อกอินหรือมีบัญชีเลย" },
      { icon: "♾️", text: "ดาวน์โหลดไม่จำกัด ไม่มีขีดจำกัดรายวัน" },
    ],
  },

  "youtube-downloader": {
    title: "ตัวดาวน์โหลดวิดีโอ YouTube — ดาวน์โหลดวิดีโอ YouTube ฟรี",
    h1: "ตัวดาวน์โหลดวิดีโอ YouTube",
    desc: "ดาวน์โหลดวิดีโอ YouTube และ Shorts ได้ฟรี บันทึกวิดีโอ MP4 หรือไฟล์เสียงลงในอุปกรณ์ของคุณโดยตรง — รวดเร็วและง่ายดาย",
    metaDesc: "ตัวดาวน์โหลดวิดีโอ YouTube ฟรี ดาวน์โหลดวิดีโอ YouTube และ Shorts เป็น MP4 หรือไฟล์เสียงอย่างเดียว ไม่ต้องสมัครสมาชิก รวดเร็วและง่ายดาย",
    keywords: "youtube downloader, ดาวน์โหลดวิดีโอ youtube, youtube video downloader, youtube shorts downloader",
    faq: [
      { q: "ดาวน์โหลดวิดีโอ YouTube อย่างไร?", a: "สลับไปที่แท็บ YouTube บน InstantSaver วาง URL วิดีโอ คลิก Preview แล้วคลิก Download" },
      { q: "ดาวน์โหลด YouTube Shorts ได้ไหม?", a: "ได้ วาง URL ของ Shorts แล้ว InstantSaver จะจัดการดาวน์โหลดให้โดยอัตโนมัติ" },
      { q: "ดาวน์โหลดคุณภาพอะไร?", a: "InstantSaver ดาวน์โหลดคุณภาพ pre-muxed ที่ดีที่สุดที่มี โดยทั่วไปสูงสุด 720p" },
      { q: "ดาวน์โหลดเฉพาะเสียงได้ไหม?", a: "ได้ หลังจากแสดงตัวอย่างวิดีโอแล้ว คลิกปุ่ม Download Audio เพื่อรับไฟล์เสียง M4A" },
    ],
    featureTitle: "ตัวเลือกการดาวน์โหลด YouTube",
    features: [
      { icon: "🎥", text: "วิดีโอ MP4 — ตัวเลือก 360p, 480p, 720p" },
      { icon: "🎵", text: "ดาวน์โหลดไฟล์เสียงอย่างเดียว M4A" },
      { icon: "⚡", text: "YouTube Shorts — เหมือนวิดีโอทั่วไป" },
      { icon: "🔒", text: "ไม่ต้องมีบัญชี" },
      { icon: "📱", text: "ใช้งานได้ทั้งมือถือและเดสก์ท็อป" },
    ],
  },

  "profile-picture-downloader": {
    title: "ตัวดาวน์โหลดรูปโปรไฟล์ Instagram — บันทึกรูปโปรไฟล์ HD",
    h1: "ตัวดาวน์โหลดรูปโปรไฟล์ Instagram",
    desc: "ดาวน์โหลดรูปโปรไฟล์ Instagram ของใครก็ได้ในขนาดเต็ม เพียงวาง URL โปรไฟล์แล้วบันทึก DP ได้ทันที",
    metaDesc: "ดาวน์โหลดรูปโปรไฟล์ Instagram (DP) ในคุณภาพต้นฉบับ วาง URL โปรไฟล์ Instagram สาธารณะใดก็ได้แล้วบันทึกรูปลงอุปกรณ์ของคุณฟรี",
    keywords: "instagram profile picture downloader, instagram dp downloader, ดาวน์โหลดรูปโปรไฟล์ instagram",
    faq: [
      { q: "ดาวน์โหลดรูปโปรไฟล์ Instagram อย่างไร?", a: "ไปที่โปรไฟล์ Instagram คัดลอก URL (เช่น instagram.com/username) วางใน InstantSaver แล้วคลิก Download Profile Picture" },
      { q: "ดาวน์โหลดรูปโปรไฟล์ของบัญชีส่วนตัวได้ไหม?", a: "ไม่ได้ สามารถเข้าถึงรูปโปรไฟล์ของบัญชีสาธารณะเท่านั้นโดยไม่ต้องล็อกอิน" },
      { q: "รูปที่ดาวน์โหลดเป็นเวอร์ชันขนาดเต็มไหม?", a: "InstantSaver ดาวน์โหลดรูปภาพคุณภาพสูงสุดที่มีจาก CDN สาธารณะของ Instagram" },
      { q: "รูปโปรไฟล์ที่ดาวน์โหลดเป็นไฟล์รูปแบบใด?", a: "รูปโปรไฟล์จะถูกบันทึกเป็นไฟล์ JPEG" },
    ],
    featureTitle: "วิธีการทำงาน",
    features: [
      { icon: "👤", text: "ใช้งานได้กับบัญชี Instagram สาธารณะใดก็ได้" },
      { icon: "🖼️", text: "ดาวน์โหลดคุณภาพสูงสุดที่มี" },
      { icon: "⚡", text: "แสดงตัวอย่างทันทีก่อนดาวน์โหลด" },
      { icon: "🔒", text: "ไม่ต้องล็อกอิน — ไม่ระบุตัวตนและเป็นส่วนตัว" },
      { icon: "📱", text: "ใช้งานได้บนทุกอุปกรณ์และเบราว์เซอร์" },
    ],
  },

  "carousel-downloader": {
    title: "ตัวดาวน์โหลด Instagram Carousel — ดาวน์โหลดรูปภาพและวิดีโอ Carousel ทั้งหมด",
    h1: "ตัวดาวน์โหลด Instagram Carousel",
    desc: "ดาวน์โหลดทุกรูปภาพและวิดีโอจากโพสต์ Carousel ของ Instagram ทีละรายการหรือทั้งหมดในคลิกเดียว",
    metaDesc: "ดาวน์โหลดรูปภาพและวิดีโอทั้งหมดจากโพสต์ Carousel ของ Instagram บันทึกแต่ละรายการหรือใช้ Download All ฟรี รวดเร็ว ไม่มีลายน้ำ",
    keywords: "instagram carousel downloader, ดาวน์โหลด instagram carousel, ดาวน์โหลดรูปภาพหลายรูป instagram",
    faq: [
      { q: "ดาวน์โหลดรูปภาพ Carousel ทั้งหมดในครั้งเดียวได้ไหม?", a: "ได้ หลังจากวาง URL ของ Carousel แล้ว InstantSaver จะแสดงทุกรายการพร้อมปุ่มดาวน์โหลดแยกต่างหาก และปุ่ม \"Download All\"" },
      { q: "ถ้า Carousel มีทั้งวิดีโอและรูปภาพปนกันล่ะ?", a: "InstantSaver ตรวจจับประเภทของแต่ละรายการโดยอัตโนมัติ — รูปภาพบันทึกเป็น JPG วิดีโอบันทึกเป็น MP4" },
      { q: "มีขีดจำกัดจำนวนรายการที่ดาวน์โหลดได้ไหม?", a: "ไม่มีขีดจำกัด InstantSaver สามารถตรวจจับและดาวน์โหลด Carousel ได้สูงสุด 20 รายการ" },
      { q: "จะได้ลิงก์ Carousel อย่างไร?", a: "บน Instagram เปิดโพสต์ แตะ ⋯ แล้วเลือก Copy Link URL จะมี /p/ อยู่ — นั่นคือโพสต์ ซึ่งอาจเป็น Carousel ได้" },
    ],
    featureTitle: "คุณสมบัติการดาวน์โหลด Carousel",
    features: [
      { icon: "🗂️", text: "ตรวจจับทุกรายการใน Carousel โดยอัตโนมัติ" },
      { icon: "⬇️", text: "ปุ่มดาวน์โหลดแยกสำหรับแต่ละรายการ" },
      { icon: "📦", text: "ปุ่ม Download All สำหรับบันทึกทั้งหมดในคลิกเดียว" },
      { icon: "🎬", text: "รองรับ Carousel ที่มีทั้งรูปภาพและวิดีโอปนกัน" },
      { icon: "✨", text: "แสดงตัวอย่างภาพขนาดย่อก่อนดาวน์โหลด" },
    ],
  },

  "stories-downloader": {
    title: "ตัวดาวน์โหลด Instagram Story — บันทึก Story ก่อนหมดอายุ",
    h1: "ตัวดาวน์โหลด Instagram Story",
    desc: "บันทึก Instagram Story สาธารณะ — รูปภาพหรือวิดีโอ — ลงในอุปกรณ์ของคุณก่อนที่จะหายไปใน 24 ชั่วโมง ไม่ต้องล็อกอิน",
    metaDesc: "ดาวน์โหลด Instagram Story ฟรี บันทึกรูปภาพและวิดีโอ Story สาธารณะก่อนหมดอายุ ไม่ต้องล็อกอิน ไม่มีลายน้ำ ใช้งานได้บนอุปกรณ์ใดก็ได้",
    keywords: "instagram story downloader, ดาวน์โหลด instagram story, instagram story saver",
    faq: [
      { q: "ดาวน์โหลด Instagram Story อย่างไร?", a: "เปิด Story บน Instagram คัดลอกลิงก์ (หรือลิงก์โปรไฟล์) วางใน InstantSaver แล้วคลิก Download" },
      { q: "ดาวน์โหลด Story แบบไม่ระบุตัวตนได้ไหม?", a: "ได้ InstantSaver ดึง Story สาธารณะโดยไม่ต้องล็อกอิน และเจ้าของบัญชีจะไม่ได้รับการแจ้งเตือน" },
      { q: "ดาวน์โหลด Story จากบัญชีส่วนตัวได้ไหม?", a: "ไม่ได้ สามารถเข้าถึง Story ของบัญชีสาธารณะเท่านั้นโดยไม่ต้องล็อกอิน" },
      { q: "เกิดอะไรขึ้นหลังจาก Story หมดอายุ?", a: "เมื่อ Story หายไปจาก Instagram แล้ว (หลังจาก 24 ชั่วโมง เว้นแต่จะถูกบันทึกเป็น Highlight) InstantSaver จะไม่สามารถดึงมาได้อีก — ดาวน์โหลดก่อนที่จะถึงเวลานั้น" },
    ],
    featureTitle: "ทำไมต้องใช้ InstantSaver สำหรับ Story",
    features: [
      { icon: "⏱️", text: "บันทึก Story ก่อนหมดอายุใน 24 ชั่วโมง" },
      { icon: "🙈", text: "ไม่ระบุตัวตน — ผู้โพสต์จะไม่ได้รับการแจ้งเตือนเลย" },
      { icon: "🎬", text: "ใช้งานได้กับ Story ทั้งแบบรูปภาพและวิดีโอ" },
      { icon: "🔒", text: "ไม่ต้องล็อกอินหรือมีบัญชี" },
      { icon: "📱", text: "ใช้งานได้บน iPhone, Android และ PC" },
    ],
  },

  "highlights-downloader": {
    title: "ตัวดาวน์โหลด Instagram Highlights — ดาวน์โหลด Story Highlights ที่บันทึกไว้",
    h1: "ตัวดาวน์โหลด Instagram Highlights",
    desc: "ดาวน์โหลดวิดีโอและรูปภาพจาก Story Highlights ของโปรไฟล์ Instagram สาธารณะ — สตอรี่ที่บันทึกไว้และปักหมุดบนโปรไฟล์",
    metaDesc: "ดาวน์โหลด Instagram Highlights ฟรี บันทึกรูปภาพและวิดีโอแต่ละรายการจาก Story Highlights ที่ปักหมุดไว้บนโปรไฟล์สาธารณะ",
    keywords: "instagram highlights downloader, ดาวน์โหลด instagram highlights, instagram highlight saver",
    faq: [
      { q: "Instagram Highlights คืออะไร?", a: "Highlights คือ Story ที่ผู้ใช้เลือกให้ปักหมุดไว้บนโปรไฟล์ของตนอย่างถาวร โดยจัดกลุ่มเป็นคอลเลกชันที่มีชื่อ" },
      { q: "ดาวน์โหลด Highlight อย่างไร?", a: "เปิด Highlight บนโปรไฟล์ คัดลอกลิงก์ วางใน InstantSaver แล้วคลิก Download" },
      { q: "ดาวน์โหลดทุกรายการใน Highlight ได้ในครั้งเดียวไหม?", a: "ได้ ในกรณีที่ Instagram อนุญาต — InstantSaver จะแสดงแต่ละสไลด์พร้อมปุ่มดาวน์โหลดของตัวเอง" },
      { q: "ต้องติดตามบัญชีเพื่อดาวน์โหลด Highlights ของพวกเขาไหม?", a: "ไม่ต้อง ตราบใดที่บัญชีนั้นเป็นบัญชีสาธารณะ" },
    ],
    featureTitle: "คุณสมบัติการดาวน์โหลด Highlights",
    features: [
      { icon: "📌", text: "ใช้งานได้กับ Highlights ที่ปักหมุดบนโปรไฟล์สาธารณะใดก็ได้" },
      { icon: "🎞️", text: "ดาวน์โหลดสไลด์รูปภาพและวิดีโอแยกรายการ" },
      { icon: "🔒", text: "ไม่ต้องล็อกอินหรือมีบัญชี" },
      { icon: "📱", text: "ใช้งานได้บน iPhone, Android และ PC" },
    ],
  },
};
